import api from './axios';

// Auth
export const authService = {
  login: (data) => api.post('/auth/login', data),
  register: (data) => api.post('/auth/register', data),
  getMe: () => api.get('/auth/me'),
};

// Dashboard
export const dashboardService = {
  getStats: () => api.get('/dashboard/stats'),
};

// File Uploads
export const uploadService = {
  uploadThumbnail: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/uploads/thumbnail', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  uploadPdf: (file, autoThumbnail = true) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/uploads/pdf?auto_thumbnail=${autoThumbnail}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  getFileUrl: (path) => {
    // Returns full URL for file
    const baseUrl = api.defaults.baseURL || '';
    return `${baseUrl}${path}`;
  }
};

// Sizes (master table)
export const sizesService = {
  getAll: (params) => api.get('/sizes', { params }),
  getActive: () => api.get('/sizes/active'),
  getOne: (id) => api.get(`/sizes/${id}`),
  create: (data) => api.post('/sizes', data),
  update: (id, data) => api.put(`/sizes/${id}`, data),
  delete: (id) => api.delete(`/sizes/${id}`),
};

// Catalogues
export const cataloguesService = {
  getAll: (params) => api.get('/catalogues', { params }),
  getActive: () => api.get('/catalogues/active'),
  getOne: (id) => api.get(`/catalogues/${id}`),
  create: (data) => api.post('/catalogues', data),
  update: (id, data) => api.put(`/catalogues/${id}`, data),
  delete: (id) => api.delete(`/catalogues/${id}`),
};

// Contacts (from Contact Us form)
export const contactsService = {
  getAll: (params) => api.get('/contacts', { params }),
  getOne: (id) => api.get(`/contacts/${id}`),
  update: (id, data) => api.put(`/contacts/${id}`, data),
  delete: (id) => api.delete(`/contacts/${id}`),
};

// Enquiries
export const enquiriesService = {
  getAll: (params) => api.get('/enquiries', { params }),
  getOne: (id) => api.get(`/enquiries/${id}`),
  create: (data) => api.post('/enquiries', data),
  update: (id, data) => api.put(`/enquiries/${id}`, data),
  delete: (id) => api.delete(`/enquiries/${id}`),
};
